// src/services/apiService.js

import axios from "axios";
import { BASE_URL } from "./constant";
const API_BASE = process.env.REACT_APP_API_BASE || BASE_URL;
//const API_BASE = process.env.REACT_APP_API_BASE || 'https://www.yaofele.com';


// Save the video
export async function uploadVideo(formData, onUploadProgress) {
  try {
    console.log("Erreur affiche:", formData);
    const response = await axios.post(`${API_BASE}/api/contents/add`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });

    return response; // tu peux aussi retourner response.data si tu préfères
  } catch (err) {
    console.warn("Upload vidéo échoué :", err);
    throw err; // pour que le composant puisse le gérer dans le try/catch
  }
}

export async function updateStatut({ id, statutpub }) {
  try {
    const res = await fetch(`${API_BASE}/api/contents/statut-pub/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ statutpub }),
    });

    return res; // 👈 OBLIGATOIRE
  } catch (err) {
    console.warn('Save reactions failed', err);
    return null;
  }
}


export async function fetchContentNotConvertAll() {
  const res = await fetch(`${API_BASE}/api/contents/notConverts/All`);
  //const res = await fetch("http://localhost:3001/api/hls/1/master.m3u8");

if (!res.ok) throw new Error('Impossible de charger le contenu');
const json = await res.json();
// return the content object (assume json contains the record or data[0] per your API)
return json.data ? json.data : json;
}
export async function fetchContentNotConvert(contentId) {
  const res = await fetch(`${API_BASE}/api/contents/notConvert/${contentId}`);
  //const res = await fetch("http://localhost:3001/api/hls/1/master.m3u8");

if (!res.ok) throw new Error('Impossible de charger le contenu');
const json = await res.json();
// return the content object (assume json contains the record or data[0] per your API)
return json.data ? json.data : json;
}
export async function fetchContentConfig() {
  const res = await fetch(`${API_BASE}/api/contents/config`);
  //const res = await fetch("http://localhost:3001/api/hls/1/master.m3u8");

if (!res.ok) throw new Error('Impossible de charger le contenu');
const json = await res.json();
// return the content object (assume json contains the record or data[0] per your API)
return json.data ? json.data : json;
}
export async function fetchContentPublication(contentId, statut) {  
  const res = await fetch(`${API_BASE}/api/contents/publication/${contentId}/${statut}`);
  //const res = await fetch("http://localhost:3001/api/hls/1/master.m3u8");

if (!res.ok) throw new Error('Impossible de charger le contenu');
const json = await res.json();
// return the content object (assume json contains the record or data[0] per your API)
return json.data ? json.data : json;
}
export async function fetchContentPublications(statut) {
  const res = await fetch(`${API_BASE}/api/contents/publications/${statut}`);
  //const res = await fetch("http://localhost:3001/api/hls/1/master.m3u8");

if (!res.ok) throw new Error('Impossible de charger le contenu');
const json = await res.json();
// return the content object (assume json contains the record or data[0] per your API)
return json.data ? json.data : json;
}
export async function fetchContentPublicationsUsers(statut,userid) {
  const res = await fetch(`${API_BASE}/api/contents/users/publications/${statut}/${userid}`);
  //const res = await fetch("http://localhost:3001/api/hls/1/master.m3u8");

if (!res.ok) throw new Error('Impossible de charger le contenu');
const json = await res.json();
// return the content object (assume json contains the record or data[0] per your API)
return json.data ? json.data : json;
}



